import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  AuthState,
  getMfaSetupRequired,
  getMfaVerificationRequired,
  getUserName,
  getUserPermissions,
  getUserProfile,
  getUserRole,
  getUserSupplierV1,
  getUserToken,
  isLoggedIn,
} from './reducers/authentication.reducers';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectUserName = createSelector(selectAuthState, getUserName);
export const selectUserRole = createSelector(selectAuthState, getUserRole);
export const selectUserToken = createSelector(selectAuthState, getUserToken);
export const selectIsLoggedIn = createSelector(selectAuthState, isLoggedIn);

export const selectUserPermissions = createSelector(selectAuthState, getUserPermissions);
export const selectUserSupplierV1 = createSelector(selectAuthState, getUserSupplierV1);

export const selectUserProfile = createSelector(selectAuthState, getUserProfile);

export const selectMfaSetupRequired = createSelector(selectAuthState, getMfaSetupRequired);
export const selectMfaVerificationRequired = createSelector(selectAuthState, getMfaVerificationRequired);
